export const URI = "Bundle";
export const single = (single) => ({
    _tag: "Single",
    single,
});
export const multiple = (multiple) => ({ _tag: "Multiple", multiple });
export const isSingle = (t) => t._tag === "Single";
export const isMultiple = (t) => t._tag === "Multiple";
export const fold = (onSingle, onMultiple) => (bundle) => {
    switch (bundle._tag) {
        case "Single":
            return onSingle(bundle);
        case "Multiple":
            return onMultiple(bundle);
    }
};

